import React from 'react';

const PendingCounter = props => (
  <div className={`pending-counter ${props.className}`}>
    {props.pending != null && props.pending > 0 ? (
      <div className="pending-count">
        <span className="notification-span">
          {props.pending < 99 ? props.pending : '99+'}
        </span>
      </div>
    ) : null}
  </div>
);

export default PendingCounter;